// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DayPicker_wrapper__1IkDJ","box":"DayPicker_box__1phQj","header":"DayPicker_header__2E2eF","day":"DayPicker_day__3tPDw"};